import type { PageSize } from 'components/editor/shared/gridConfig.ts';
import useDownloadAsPdf from './useDownloadAsPdf.ts';

type PdfDownloadButtonForExportingServiceProps = {
  pageSize?: PageSize;
};

const PdfDownloadButtonForExportingService = ({ pageSize }: PdfDownloadButtonForExportingServiceProps) => {
  const printPdf = useDownloadAsPdf({
    pageSize,
    printingFunction: async (iframe) => {
      document.write(iframe.contentDocument?.documentElement.outerHTML || '');
    },
  });

  return <button id="print-pdf-button" hidden={true} onClick={printPdf} />;
};

export default PdfDownloadButtonForExportingService;
